import { useEffect, useState } from 'react';
import { depositFormService } from '../api/services';
import { listLocalDrafts } from '../utils/depositDrafts';
import { findCustomerDrafts, normalizeCustomerIdentity, normalizeCustomerPhone } from '../utils/draftCustomers';

export default function useCustomerDraftWarning({ userId, currentId, ready, completed, phone, cccd }) {
  const [matches, setMatches] = useState([]);
  const [unavailable, setUnavailable] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setMatches([]); setUnavailable(false);
    if (!userId || !ready || completed || (!normalizeCustomerPhone(phone) && !normalizeCustomerIdentity(cccd))) return undefined;
    const timer = setTimeout(async () => {
      const [remote, local] = await Promise.allSettled([depositFormService.getDrafts(), listLocalDrafts(userId)]);
      if (cancelled) return;
      setMatches(findCustomerDrafts(remote.status === 'fulfilled' ? remote.value : [], local.status === 'fulfilled' ? local.value : [], currentId, { phone, cccd }));
      setUnavailable(remote.status === 'rejected');
    }, 400);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [userId, currentId, ready, completed, phone, cccd]);
  return { matches, unavailable };
}
